const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

export function initBanner() {
    const banner = document.querySelector('.banner');
    if (!banner) {
        return;
    }

    /** @type {HTMLPictureElement[]} */
    const pictures = [...banner.querySelectorAll('.banner-image-picture')];
    if (pictures.length === 1) {
        return;
    }

    let step = 0;

    const keywords = banner.querySelector('.banner-header-keywords');
    const wheel = banner.querySelector('.banner-wheel img');

    /** @type {HTMLSpanElement} */
    let currentKeyword;

    setInterval(() => {
        currentKeyword?.remove();
        step++;

        pictures.forEach((picture, idx) => {
            const active = (step % pictures.length) === idx;
            picture.classList.toggle('banner-image-picture--active', active);

            if (!active) {
                return;
            }

            banner.dataset.theme = picture.dataset.color;

            currentKeyword = keywords.firstElementChild;
            const nextKeyword = document.createElement('span');
            nextKeyword.classList.add('banner-header-keyword', `text-color-${picture.dataset.color}`);
            nextKeyword.innerText = picture.dataset.label;

            currentKeyword.animate(
                [
                    reducedMotion
                        ? {
                            opacity: 0,
                        }
                        : {
                            transform: 'translateY(-100%)',
                        },
                ],
                {
                    duration: 1000,
                    fill: 'forwards',
                    easing: 'ease-in-out',
                },
            );

            keywords.append(nextKeyword);
            nextKeyword.animate(
                reducedMotion
                    ? [
                        {
                            opacity: 0,
                        },
                        {
                            opacity: 1,
                        },
                    ]
                    : [
                        {
                            transform: 'translateY(100%)',
                        },
                        {
                            transform: 'translateY(0%)',
                        },
                    ],
                {
                    duration: 1000,
                    fill: 'forwards',
                    easing: 'ease-in-out',
                },
            );
        });

        if (!reducedMotion) {
            wheel.animate(
                [
                    {
                        transform: 'rotate(45deg)',
                    },
                ],
                {
                    duration: 1000,
                    fill: 'forwards',
                    composite: 'add',
                    easing: 'ease-in-out',
                },
            );
        }

    }, 5000);
}